import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Button from '@mui/material/Button';
import { LoadingButton } from 'src/components/buttons/LoadingButton';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { useAuth } from 'src/contexts/AuthContext';
import { AuthenticationFlowPageProps } from '../AuthenticationFlow';
import { useRouter } from 'next/router';
import { useRemoveQueryParams } from 'src/hooks/useRemoveQueryParams';

export type AuthenticationVerifyingEmailSuccessPageProps =
  AuthenticationFlowPageProps;

export const AuthenticationVerifyingEmailSuccessPage = ({
  pageId: pageID,
  onPageComplete,
}: AuthenticationVerifyingEmailSuccessPageProps) => {
  const { user } = useAuth();
  const router = useRouter();
  useRemoveQueryParams();

  return (
    <Stack spacing="32px" my={8}>
      <GradientTypography
        gradientColor="primary.vertical"
        variant="h4"
        fontWeight="500"
        textAlign="center"
        sx={{ textTransform: 'uppercase' }}
      >
        Welcome to BluMint!
      </GradientTypography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Icon
          component={CheckCircleRoundedIcon}
          color="secondary"
          sx={{ width: 100, height: 100 }}
        />
      </Box>
      <Typography variant="h6" textAlign="center">
        Your email has been verified.
      </Typography>
      {user && user.emailVerified ? (
        <Stack spacing="8px">
          <LoadingButton
            variant="outlined"
            sx={{ height: '40px' }}
            onClick={async () => {
              onPageComplete(pageID);
              await router.push(`/profile/${user?.uid}`);
            }}
          >
            Edit profile
          </LoadingButton>
          {/* TODO <Button
              variant="outlined"
              sx={{ height: '40px' }}
              onClick={handleConnectWallet}
            >
              Connect wallet
            </Button> */}
          <Button
            variant="outlined"
            sx={{ height: '40px' }}
            onClick={() => {
              onPageComplete(pageID);
            }}
          >
            Continue Browsing
          </Button>
        </Stack>
      ) : (
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            onPageComplete(pageID, 'email sign in');
          }}
        >
          Sign In
        </Button>
      )}
    </Stack>
  );
};
